import { USER_PROFILE_STATUS } from "../static-data";
import EnvVar from "./EnvVar";

import {
  OTHER_COUNTRY_CODE,
  PLATFORMS,
  PRICING_TIERS,
  TARGET_ENVIRONMENTS,
  CREATE_FLOW_VERSIONS,
} from "./constant";

const commonConfig = {
  PLATFORMS: PLATFORMS,
  CURRENT_PLATFORM: EnvVar.PLATFORM,
  TARGET_ENVIRONMENTS,
  TARGET_ENVIRONMENT: EnvVar.ENVIRONMENT,
  REACT_APP_WEB_URL: EnvVar.REACT_APP_WEB_URL,
  CREATE_FLOW_VERSIONS,
  CREATE_FLOW_VERSION: EnvVar.CREATE_FLOW_VERSION,
  OTHER_COUNTRY_CODE,
  PRICING_TIERS_ORDER: [],
  ADS_OVERVIEW_PAGE_SIZE: 25,
  MAGAZINE_EXCLUDED_PACKAGES: [PRICING_TIERS["1M_BASIC"]],
  FOLLOW_UP_COMMENTS_BLOCKED_POST_STATUSES: [USER_PROFILE_STATUS.INCOMPLETE],
};

const getConfigByPlatform = () => {
  const config = { ...commonConfig };
  switch (EnvVar.PLATFORM) {
    case PLATFORMS.LK:
      config.POST_IMAGE_SLOTS = 3;
      config.HOROSCOPE_IMAGE_SLOTS = 2;
      config.OTHER_PROFESSION_ID = 7;
      config.PRICING_TIERS_ORDER = [
        "1m",
        "2m",
        "3m",
        "1m_basic",
        "2m_basic",
        "3m_basic",
        "3m_pro",
        "6m_vip",
      ];
      break;
    case PLATFORMS.IN:
      config.POST_IMAGE_SLOTS = 5;
      config.HOROSCOPE_IMAGE_SLOTS = 3;
      config.OTHER_PROFESSION_ID = 147;
      break;
    default:
      break;
  }

  return config;
};

const Config = getConfigByPlatform();
export default Config;
